import React from "react";
import { IconProps } from "../icon";

export const ArrowNarrowUpRightIcon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path stroke={color} strokeLinecap="square" strokeWidth="2" d="M6 18L18 6m0 0h-8m8 0v8" />
  </svg>
);
